import { looseEqual } from '../../lib/utilities'
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop, Watch } from 'vue-property-decorator'

@Component
export default class FormOptionsMixin extends Vue  {
  localValue: any = ""

  @Prop({default: false})
  public multiple: boolean

  @Prop({default: null})
  public value: string | Array<any>

  @Prop({default: false})
  public disabled: boolean

  @Prop({default: false})
  public appendToBody: boolean

  created () {
    this.localValue = JSON.parse(JSON.stringify(this.value))
  }

  @Watch('value')
  onValueChange(val: any, oldVal: any) {
    this.localValue = JSON.parse(JSON.stringify(val))
  }

  @Watch('localValue')
  onLocalValueChange(val: any, oldVal: any) {
    if (!looseEqual(val, this.value)) {
      this.$emit('input', val)
    }
  }
}
